<template>
  <div class="pa-3">
      <v-row no-gutters>
        <v-col md="12">
          <v-card>
            <v-card-title class="accent text-customizer-exp">
              {{ $t("dashboard.menu.eventsBrands.title") }} {{ this.$store.state.eventname }}
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="brands"
                sort-by="name"
                class="elevation-1"
                :no-data-text="$t('dashboard.menu.eventsBrands.no_data_available')"
                :footer-props="{
                  'items-per-page-text': $t('dashboard.menu.eventsBrands.items_per_page_text'),
                  'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                }"
                :headerProps="{
                  'sort-by-text': $t('dataTable.sortByText')
                }"
                :search="search" 
                :no-results-text="$t('dataTable.no_matching_records')"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-dialog v-model="dialog" max-width="500px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 mr-2"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon class="icon_top">fas fa-plus</v-icon>
                          {{ $t("dashboard.menu.eventsBrands.create_new_brand") }}
                        </v-btn>
                      </template>
                      <v-card>
                        <v-form ref="form">
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col md="12">
                                  <v-text-field
                                    outlined
                                    v-model="form.name"
                                    :label="$t('dashboard.menu.eventsBrands.name')"
                                    :rules="rules.name"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-row>
                              <v-col md="12" class="text-right">
                                <v-btn
                                  color="darken-1"
                                  dark small
                                  class="mb-2 mr-2"
                                  :disabled="!brandsFormIsValid"
                                  @click="brandApi()"
                                  >{{ btmTitle }}</v-btn
                                >
                              </v-col>
                            </v-row>
                          </v-card-actions>
                        </v-form>
                      </v-card>
                    </v-dialog>
                    <!--No se pudo verificar-->
                    <v-dialog v-model="dialogDelete" max-width="500px">
                      <v-card>
                        <v-card-title class="headline">{{
                          $t("dashboard.menu.eventsBrands.delete_record")
                        }}</v-card-title>
                        <v-card-text>
                          <p>{{ $t("dashboard.menu.eventsBrands.sure_delete") }}</p>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-row>
                            <v-col md="12" class="text-right">
                              <v-btn color="blue darken-1" text @click="closeDelete">{{
                                $t("dashboard.menu.eventsBrands.cancel")
                              }}</v-btn>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="deleteItemConfirm"
                                >{{ $t("dashboard.menu.eventsBrands.delete") }}</v-btn
                              >
                            </v-col>
                          </v-row>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                  <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">{{$t('common.reset')}}</v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
  </div>
</template>
<script>
import { apiCalls } from "@/mixins/apiCalls.js";
export default {
  name: "EventBrands",
  mixins: [apiCalls],
  data() {
    const brandForm = Object.freeze({
      name: "",
    });
    return {
      userId: null,
      event: {},
      snackbar: false,
      snackbarError: false,
      msgError: "",
      dialog: false,
      dialogDelete: false,
      dialogImport: false,
      brands: [],
      editedIndex: -1,
      editedItem: {
        name: "",
      },
      defaultItem: {
        name: "",
      },
      brandForm,
      form: Object.assign({}, brandForm),
      search: "",
    };
  },
  methods: {
    loadEvent: async function () {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventClass/getEvent/" + this.$route.params.id
      );

      if(response.success == 1){
        this.event = response.message[0];
        this.userId = response.message[0].userId;
        this.initialize();
      }
      
    },
    initialize: async function () {

      var response = await this.api(
        "get",
        `/api/v1/promoter/brand/${this.userId}/${this.$route.params.id}`
      );

      this.brands = response.message;
    },

    editItem(item) {
      this.editedIndex = this.brands.indexOf(item);
      this.form = item;
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.brands.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.brands.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete: async function () {
      
      await this.deleteApi(`/api/v1/promoter/brand/${this.userId}/${this.editedItem.id}`, {});

      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.brands[this.editedIndex], this.editedItem);
      } else {
        this.brands.push(this.editedItem);
      }
      this.close();
    },

    brandApi: async function () {

      let data = {};
      this.dialog = false;
      
      if(this.editedIndex == -1){
        data.eventId = this.$route.params.id;
        data.userId = this.userId;
        data.brandName = this.form.name;

        await this.postApi("/api/v1/promoter/brand", data);
        
      } else {
        
        data.id = this.form.id;
        data.userId = this.userId;
        data.brandName = this.form.name;

        await this.putApi("/api/v1/promoter/brand",data);
      }

      this.initialize();

    }
  },
  computed: {
    btmTitle() {
      return this.editedIndex === -1
        ? this.$t("dashboard.menu.eventsBrands.create")
        : this.$t("dashboard.menu.eventsBrands.edit");
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("dashboard.menu.eventsBrands.create_new_entry")
        : this.$t("dashboard.menu.eventsBrands.edit_record");
    },
    headers() {
      return [
        {
          text: this.$t("dashboard.menu.eventsBrands.name"),
          align: "start",
          sortable: false,
          value: "brandName",
          width: "80%",
        },
        {
          text: this.$t("dashboard.menu.eventsBrands.edit_delete"),
          value: "actions",
          sortable: false,
        },
      ];
    },
    brandsFormIsValid() {
      return this.form.name;
    }, 
    rules() {
      return {
        name: [
          (val) =>
            (val || "").length > 0 ||
            this.$t("dashboard.menu.eventsBrands.name_required"),
        ],
      };
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    // this.initialize();
    this.loadEvent();
  },
};
</script>
<style>
.icon-top{
  margin-right: 5px;
}
</style>
